import { useEffect, useState } from 'react';

import { getFinalOffer } from '../api/getFinalOffer';
import { FinalOffer } from '../types/OfferTypes';
import { useAppSelector } from './hooks';
import useArnFromPath from './useArnFromPath';
import useSettings from './useSettings';
/**
 * Runs the service for get final offer
 * @returns an object with the final offer
 */

const useGetFinalOffer = () => {
    const { authenticationData } = useAppSelector((state) => state.authentication);
    const { apiKey, proxyBaseUrl } = useSettings();
    const applicationReferenceNumber = useArnFromPath();
    const [finalOffer, setFinalOffer] = useState<FinalOffer>();

    useEffect(() => {
        if (!applicationReferenceNumber) {
            return;
        }
        getFinalOffer(proxyBaseUrl, apiKey, applicationReferenceNumber, authenticationData)
            .then((offer) => {
                setFinalOffer(offer);
            })
            .catch(() => {
                'error';
            });
    }, [applicationReferenceNumber]);

    return { finalOffer };
};
export default useGetFinalOffer;
